import React, { useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import M from '@materializecss/materialize';

const GeneralTab = ({ pharmacy }) => {
  useLayoutEffect(() => {
    M.Tooltip.init(document.querySelectorAll('.tooltipped'), {
      enterDelay: 500,
    });

    return () => {
      document
        .querySelectorAll('.tooltipped')
        .forEach(el => (el ? M.Tooltip.getInstance(el).destroy() : null));
    };
  }, []);

  const autoAdjustHeight = () => {
    const labelElements = document.querySelectorAll('table#t-labels>tbody>tr');
    const valueElements = document.querySelectorAll('table#t-values>tbody>tr');

    labelElements.forEach((el, index) => {
      valueElements[index].style.height = `${el.clientHeight}px`;
    });
  };

  useLayoutEffect(() => {
    autoAdjustHeight();
  }, [pharmacy]);

  useEffect(() => {
    window.addEventListener('resize', autoAdjustHeight);
    return () => {
      window.removeEventListener('resize', autoAdjustHeight);
    };
  }, []);

  return (
    <div style={{ padding: '1vw' }}>
      <div className="row">
        <Link to="/pharmacy/create">
          <i
            className="material-icons tooltipped"
            data-position="top"
            data-tooltip="Create New Pharmacy"
            style={{
              border: '1px solid #2196f3',
              padding: '4px 2px',
              borderRadius: '3px',
              marginRight: '8px',
            }}
          >
            add
          </i>
        </Link>
        <Link to={`/pharmacy/${pharmacy.id}/update`}>
          <i
            className="material-icons tooltipped"
            data-position="top"
            data-tooltip="Edit Pharmacy"
            style={{
              border: '1px solid #2196f3',
              padding: '4px 2px',
              borderRadius: '3px',
              marginRight: '8px',
            }}
          >
            edit
          </i>
        </Link>
      </div>
      <div className="row">
        <div className="col s4 m3 l2">
          <table id="t-labels">
            <tbody>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  ID
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Customer Number
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Name
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Phone
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Email
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  DEA Number
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Hospital?
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Government?
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  340B?
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Veteran's Affairs?
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  340B Number
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Default Fee Percentage
                </td>
              </tr>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Notes
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col s8 m9 l10">
          <table id="t-values" className="highlight">
            <tbody>
              <tr>
                <td style={{ padding: '4px' }}>{pharmacy.id}</td>
              </tr>
              <tr>
                <td style={{ padding: '4px' }}>{pharmacy.customerNumber}</td>
              </tr>
              <tr>
                <td style={{ padding: '4px' }}>{pharmacy.name}</td>
              </tr>
              <tr>
                <td style={{ padding: '4px' }}>
                  {pharmacy.phone || <span>&nbsp;</span>}
                </td>
              </tr>
              <tr>
                <td style={{ padding: '4px' }}>
                  {pharmacy.email || <span>&nbsp;</span>}
                </td>
              </tr>
              <tr>
                <td style={{ padding: '4px' }}>
                  {pharmacy.deaNumber || <span>&nbsp;</span>}
                </td>
              </tr>
              <tr>
                <td style={{ padding: '4px' }}>
                  {pharmacy.isHospital ? 'Yes' : 'No'}
                </td>
              </tr>
              <tr>
                <td style={{ padding: '4px' }}>
                  {pharmacy.isGov ? 'Yes' : 'No'}
                </td>
              </tr>
              <tr>
                <td style={{ padding: '4px' }}>
                  {pharmacy.is340b ? 'Yes' : 'No'}
                </td>
              </tr>
              <tr>
                <td style={{ padding: '4px' }}>
                  {pharmacy.isVa ? 'Yes' : 'No'}
                </td>
              </tr>
              <tr>
                <td style={{ padding: '4px' }}>
                  {pharmacy.threeFortyBNumber || <span>&nbsp;</span>}
                </td>
              </tr>
              <tr>
                <td style={{ padding: '4px' }}>
                  {pharmacy.defaultFeePercentage || <span>&nbsp;</span>}%
                </td>
              </tr>
              <tr>
                <td style={{ padding: '4px' }}>
                  {pharmacy.notes || <span>&nbsp;</span>}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GeneralTab;
